module.exports = __webpack_public_path__ + "static/media/caret-up.068759c3.svg";